module.exports = __webpack_public_path__ + "static/img/relief06.8c6f304.bmp";


//////////////////
// WEBPACK FOOTER
// ./src/views/reliefVase/imgs/relief06.bmp
// module id = /WlP
// module chunks = 2